import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { AuthenticationServiceToken, IAuthenticationService } from './account-services';

export const AccountHeaderResolver: ResolveFn<string | null> = (route: ActivatedRouteSnapshot) => {
  const authenticationService: IAuthenticationService = inject(AuthenticationServiceToken);
  return authenticationService.setHeaderDataField(route);
};
